module.exports = __webpack_public_path__ + "media/images/youth_citizens_science/logo_banner/image 005-41dd8aac1b08104930e39ff1516bb4d9.png";